
<style lang="less">
#generate-qrcode-content {
  .qrcode-outer {
    width: 100%;
    border-radius: @borderRadiusMin;
    border: 1px solid @lineColorNormal;
    text-align: center;
    #qrcodeOuter {
      width: 350px;
      margin: 0 auto;
      padding: 20px 20px @containerGap;
      box-sizing: border-box;
      #qrcode {
        position: relative;
        img {
          margin: 0 auto;
        }
        &:after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 50px;
          height: 50px;
          background: transparent url("/logo/logoSmall.png") no-repeat;
          background-size: 100% 100%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
      .tips {
        word-break: break-all;
        margin: @containerGap 0 @containerGap * 0.5;
        font-size: 15px;
        font-weight: 500;
        color: @strongColor;
      }
      .recharge-info {
        width: 200px;
        margin: 0 auto;
        text-align: left;
        line-height: 26px;
        font-size: 13px;
        color: @textColorNormal;
      }
    }
  }
}
</style>

<template>
  <div id="generate-qrcode-content">
    <div class="qrcode-outer">
      <div id="qrcodeOuter">
        <div id="qrcode" />
        <div class="tips">
          请使用微信扫码，在{{ model.timeExpire || '-' }}分钟内支付
        </div>
        <div class="recharge-info">
          <div>生成时间：{{ model.time || '-' }}</div>
          <div>充值账户：{{ model.tel || '-' }}</div>
          <div>充值金额：{{ model.money || '-' }}元</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';

export default {
  components: {},
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      qrCodeSingle: null
    };
  },
  created () {
    this.$nextTick(() => {
      console.log(this.model);
      this.creatQrcode();
    });
  },
  methods: {
    /** ******************* 工具方法开始 ******************* **/
    // 创建二维码
    creatQrcode () {
      this.qrCodeSingle = new QRCode(document.getElementById('qrcode'), {
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff'
      });
      this.drawQrcode();
    },
    /** ******************* 工具方法结束 ******************* **/

    /** ******************* 回调事件开始 ******************* **/
    onClose () {
      this.$emit('on-close');
    },
    // 绘制二维码
    drawQrcode () {
      console.log('draw ....');
      this.qrCodeSingle.makeCode(this.model.codeUrl);
    }
    /** ******************* 回调事件结束 ******************* **/
  }
};
</script>
